import { logout } from '@/redux/slices/user.slice';
import {
  fetchAutoregistry,
  getAutoregistryMonthMap,
} from '@/redux/thunks/autoregistry.thunk';
import { createSlice } from '@reduxjs/toolkit';

interface AutoregistryState {
  data: any | null;
  loading: boolean;
  success: boolean;
  error: any | boolean;
  calendarStatus: 'loading' | 'success' | 'error' | 'idle';
  calendarData: any | null;
}

const initialState: AutoregistryState = {
  data: [],
  loading: false,
  success: true,
  error: false,
  calendarData: [],
  calendarStatus: 'idle',
};

const autoregistrySlice = createSlice({
  name: 'autoregistry',
  initialState,
  reducers: {
    clearAutoregistry: (state) => {
      Object.assign(state, initialState);
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchAutoregistry.pending, (state) => {
        state.loading = true;
        state.success = false;
        state.error = false;
      })
      .addCase(fetchAutoregistry.fulfilled, (state, action) => {
        state.loading = false;
        state.success = true;
        state.data = action.payload;
      })
      .addCase(fetchAutoregistry.rejected, (state, action) => {
        state.loading = false;
        state.success = false;
        state.error = action.error;
      });
    builder
      .addCase(logout, (state) => {
        Object.assign(state, initialState);
      })
      .addCase(getAutoregistryMonthMap.pending, (state) => {
        state.calendarStatus = 'loading';
        state.calendarData = [];
      })
      .addCase(getAutoregistryMonthMap.fulfilled, (state, action) => {
        state.calendarStatus = 'success';
        state.calendarData = action.payload;
      })
      .addCase(getAutoregistryMonthMap.rejected, (state, action) => {
        state.calendarStatus = 'error';
        state.calendarData = [];
      });
  },
});

export const { clearAutoregistry } = autoregistrySlice.actions;
export default autoregistrySlice.reducer;
